import PropTypes from 'prop-types'
import { calcularTotalItemConIva } from '../helpers/calcularPrecioTotal'
import Precios from '../reutilizables/precios/Precios'

const IVA_ENVIO = 1.21
const MAX_DECIMALES = 2

const DetalleCobro = ({
  precio,
  cantidad,
  monedaSimbolo,
  exposicion,
  precioExposicion,
  alicuota,
  precioEnvio
}) => {
  const precioUnitario = Number(precio) || 0
  const cantidadNumerica = Number(cantidad) || 1
  const alicuotaNumerica = Number(alicuota) || 0
  const porcentajeExposicion = Number(precioExposicion) || 0
  const ventaTotal = calcularTotalItemConIva({
    precioUnitario,
    cantidad: cantidadNumerica,
    alicuota: alicuotaNumerica
  })
  const descuentoExposicion = (porcentajeExposicion * ventaTotal) / 100
  const envioConIva = (Number(precioEnvio) || 0) * IVA_ENVIO
  const totalCalculado = ventaTotal - descuentoExposicion + envioConIva
  const descuentoExposicionFormateado = Number(descuentoExposicion).toLocaleString(
    'es-AR',
    { maximumFractionDigits: MAX_DECIMALES }
  )

  return (
    <div className="row">
      <div className="col">
        <div className="row">
          <div className="col">
            <h3 className="text-left">Detalle de Cobro</h3>
          </div>
        </div>
        <div className="row">
          <div className="col ml-5 mr-5">
            <div className="row">
              <div className="col">
                <p>
                  <b>Descripción</b>
                </p>
              </div>
              <div className="col">
                <p>
                  <b>Importe</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <p>Venta (x {cantidad})</p>
              </div>
              <div className="col">
                <Precios
                  precio={precioUnitario}
                  monedaSimbolo={monedaSimbolo}
                  alicuota={alicuotaNumerica}
                  cantidad={cantidadNumerica}
                  showSinIVA={true}
                />
              </div>
            </div>
            {precioEnvio > 0 && (
              <div className="row">
                <div className="col-6">
                  <p className="">Envío</p>
                </div>
                <div className="col-6">
                  <Precios
                    precio={precioEnvio}
                    monedaSimbolo={monedaSimbolo}
                    alicuota={21}
                    showSinIVA={true}
                  />
                </div>
              </div>
            )}
            <div className="row mt-2">
              <div className="col-6">
                <p className="">
                  Exposición {exposicion} ({porcentajeExposicion}%)
                </p>
              </div>
              <div className="col-6">
                <p>
                  -
                  <b>
                    {monedaSimbolo}
                    {descuentoExposicionFormateado}
                  </b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col text-right">
                <b>Total</b>
              </div>
              <div className="col">
                <Precios
                  precio={totalCalculado}
                  monedaSimbolo={monedaSimbolo}
                  alicuota={0}
                  showSinIVA={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DetalleCobro.propTypes = {
  precio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cantidad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  monedaSimbolo: PropTypes.string.isRequired,
  exposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  precioExposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  precioEnvio: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default DetalleCobro
